/* @flow */
import Columns2 from 'components/Columns2';
import Image from 'components/Image';
import * as React from 'react';
import Text from 'components/Text';
import TextAppLinkForm from 'user/components/TextAppLinkForm';

import './styles/TextAppLink.scss';

export default class extends React.Component<{}> {
  render() {
    return (
      <div className="TextAppLink">
        <Columns2 reset="tablet" flex>
          <div>
            <h1 className="TextAppLink-title">Get the Remind app</h1>
            <Text color="graphite" element="p" size="small">
              Send and receive messages instantly on your phone.
            </Text>
            <TextAppLinkForm />
          </div>
          <Image
            src={require('assets/images/TextAppLink/apps.png')}
            srcSet={`${require('assets/images/TextAppLink/apps@2x.png')} 2x`}
            alt="Remind mobile apps"
          />
        </Columns2>
      </div>
    );
  }
}
